(function() {
  const root = document;

  function getPrimaryImage(el) {
    const card = el.closest('.card-wrapper') || el.closest('.card');
    if (!card) return null;
    return card.querySelector('img[data-primary-image="true"]') || card.querySelector('.card__media img');
  }

  function swapImage(img, src, srcset, sizes) {
    if (!img || !src) return;
    if (!img.dataset.origSrc) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
      img.dataset.origSizes = img.getAttribute('sizes') || '';
    }
    if (srcset) img.setAttribute('srcset', srcset);
    if (sizes) img.setAttribute('sizes', sizes);
    img.setAttribute('src', src);
  }

  function restoreImage(img) {
    if (!img || !img.dataset.origSrc) return;
    img.setAttribute('src', img.dataset.origSrc);
    if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
    if (img.dataset.origSizes) img.setAttribute('sizes', img.dataset.origSizes);
  }

  // Hover: nur Farbswatches
  root.addEventListener('mouseenter', function(e) {
    const swatch = e.target.closest('.st-swatch--color');
    if (!swatch) return;
    const img = getPrimaryImage(swatch);
    const src = swatch.getAttribute('data-variant-src');
    const srcset = swatch.getAttribute('data-variant-srcset');
    const sizes = swatch.getAttribute('data-variant-sizes');
    if (src) swapImage(img, src, srcset, sizes);
  }, true);

  root.addEventListener('mouseleave', function(e) {
    const swatch = e.target.closest('.st-swatch--color');
    if (!swatch) return;
    const img = getPrimaryImage(swatch);
    restoreImage(img);
  }, true);

  // Tap auf Mobile: setzt Bild; Wechsel zurück bei Mouseleave o. neuem Hover
  root.addEventListener('click', function(e) {
    const swatch = e.target.closest('.st-swatch--color');
    if (!swatch) return;
    const img = getPrimaryImage(swatch);
    const src = swatch.getAttribute('data-variant-src');
    const srcset = swatch.getAttribute('data-variant-srcset');
    const sizes = swatch.getAttribute('data-variant-sizes');
    if (src) swapImage(img, src, srcset, sizes);
  }, true);
})();